// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FlowCanvasController from "./flow_canvas_controller"
application.register("flow-canvas", FlowCanvasController)

// F10 interactive link magnets
import ManychatCalculatorController from "./manychat_calculator_controller"
application.register("manychat-calculator", ManychatCalculatorController)

import ReplyRateQuizController from "./reply_rate_quiz_controller"
application.register("reply-rate-quiz", ReplyRateQuizController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import HeroScenariosController from "./hero_scenarios_controller"
application.register("hero-scenarios", HeroScenariosController)
